import { memo } from 'react';
import { Button, ButtonProps } from '@mui/material';

const PmiButtonComponent = ({ children, ...props }: ButtonProps): React.ReactElement => {
  return <Button {...props}>{children}</Button>;
};

PmiButtonComponent.displayName = 'Button Field component';

export const PmiButton = memo(PmiButtonComponent) as typeof PmiButtonComponent;
